
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface DashboardSearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const DashboardSearchBar = ({ value, onChange }: DashboardSearchBarProps) => (
  <div className="mb-6">
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
      <Input
        placeholder="Search articles, users, or categories..."
        className="pl-10"
        value={value}
        onChange={onChange}
      />
    </div>
  </div>
);

export default DashboardSearchBar;
